// @dynamic
export class RegisterActions {
  static REGISTER_REQUEST = '[register] REGISTER_REQUEST';
  static REGISTER_SUCCESS = '[register] REGISTER_SUCCESS';
  static REGISTER_FAILURE = '[register] REGISTER_FAILURE';

  static registerUser = payload => ({ type: RegisterActions.REGISTER_REQUEST, payload });
  static registerSuccess = payload => ({ type: RegisterActions.REGISTER_SUCCESS, payload });
  static registerFailure = payload => ({ type: RegisterActions.REGISTER_FAILURE, payload });
}
